import { CartSummary } from '@/components/modules/_shared/CartSummary/CartSummary';
import { useAutoUpdateCartSummaryData } from '@/components/modules/Application/hooks/useAutoUpdateCartSummaryData';
import { ChangesReview } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/components/ChangesReview';
import {
  DialogStepContent,
  DialogStepProps,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/components/DialogStepContent';
import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { useCheckoutSessionCart } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSessionCart';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { hasSelectedAgentOnlyAutoPaymentMethods } from '@/utils/hasSelectedAgentOnlyAutoPaymentMethods';

interface CartChangesReviewProps extends DialogStepProps {
  loading: boolean;
}

export const CartChangesReview = ({ onNext, onPrev, loading }: CartChangesReviewProps) => {
  const {
    state: { selectedAgent },
  } = useApplicationContext();
  const { paymentMethodDetailEntities } = useCheckoutSessionContext();

  // Edited values from the application context
  const {
    state: { downPayment: editedDownPayment, cart: editedCart, cartSummaryData: editedCartSummaryData },
  } = useApplicationContext();

  // Original values from the checkout session context
  const {
    cartSummaryData: originalCartSummaryData,
    downPayment: originalDownPayment,
    discount: originalDiscount,
  } = useCheckoutSessionCart();

  // Keep the application context cart summary data updated when products are added/removed/edited
  useAutoUpdateCartSummaryData();

  // Decide type of cart
  const isAutoCart = hasSelectedAgentOnlyAutoPaymentMethods(selectedAgent);

  return (
    <DialogStepContent
      titleTextId={'CHANGES_REVIEW'}
      descriptionTextId={'CHANGES_REVIEW_DESCRIPTION'}
      onNext={onNext}
      onPrev={onPrev}
      loading={loading || !paymentMethodDetailEntities || !editedDownPayment || !originalCartSummaryData}
    >
      <ChangesReview
        originalDataTitleTextId={isAutoCart ? 'ORIGINAL_VEHICLE' : 'ORIGINAL_CART'}
        newDataTitleTextId={isAutoCart ? 'NEW_VEHICLE' : 'NEW_CART'}
        OriginalDataComponent={
          <CustomPaper fill="error.light" style={{ border: '1px solid red' }}>
            {originalCartSummaryData && originalDownPayment && (
              <CartSummary
                cartSummaryData={originalCartSummaryData}
                downPayment={originalDownPayment}
                discount={originalDiscount}
                strikethrough
              />
            )}
          </CustomPaper>
        }
        NewDataComponent={
          <CustomPaper fill="paper">
            {editedCartSummaryData && (
              <CartSummary
                cartSummaryData={editedCartSummaryData}
                downPayment={editedDownPayment}
                discount={editedCart?.totalDiscount()}
              />
            )}
          </CustomPaper>
        }
      />
    </DialogStepContent>
  );
};
